import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import toast from 'react-hot-toast';
import { SERVER_URL } from '../../../../../Config/config';
import axiosInstance from '../../../../../store/axiosInstance';

export const fetchValidationUsers = createAsyncThunk('users/fetchUsers', async (_, { rejectWithValue }) => {
  try {
    const response = await axiosInstance.get(`${SERVER_URL}/api/v1/validation/validation-Users`);
    console.log('response', response);
    return response.data.users;
  } catch (error) {
    toast.error(error.response?.data?.message || 'Failed to fetch users');
    return rejectWithValue(error.response?.data?.message);
  }
});


const validationUsersSlice = createSlice({
  name: 'validationUsers',
  initialState: {
    validationUsers: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchValidationUsers.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchValidationUsers.fulfilled, (state, action) => {
        state.loading = false;
        state.validationUsers = action.payload;
      })
      .addCase(fetchValidationUsers.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default validationUsersSlice.reducer;